export default __webpack_public_path__ + "6b46cf9c66fb3a56204dd74a7b302055.png";